import styled from '@emotion/styled';
import { Stack } from '@mui/material';

import { scrollbarStyles, theme } from '@/shared/design-system';
import { hoverable } from '@/shared/design-system/interaction-states';
import { shadows } from '@/shared/design-system/shadows';

export const ReviewSections = styled(Stack)({
  flexDirection: 'column',
  gap: '20px',
});

export const FieldSection = styled(Stack)({
  flexDirection: 'column',
  alignSelf: 'stretch',
  gap: '8px',
});

export const FieldRows = styled(Stack)({
  flexDirection: 'column',
  gap: '8px',
});

export const ValueRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '8px',
  '& > *': { flex: '0 0 auto' },
  '& > *:first-child': { flex: '1 1 auto', minWidth: 0 },
});

export const AddSectionRow = styled(Stack)({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '8px',
});

export const SocialRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '8px',
  '& > *': { flex: '0 0 auto' },
  '& > *:first-child': { width: '144px', flex: '0 0 144px' },
  '& > *:nth-child(2)': { flex: '1 1 auto', minWidth: 0 },
});

export const AnnotationSlot = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  height: '40px',
});

export const SuggestionList = styled('div')({
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: 0,
  right: 0,
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '224px',
  overflowY: 'auto',
  padding: '4px',
  backgroundColor: theme.colors.background.raised,
  border: `1px solid ${theme.colors.border.default}`,
  borderRadius: theme.radius[12],
  boxShadow: shadows.md,
  ...scrollbarStyles,
});

export const SuggestionItem = styled('button')(({ theme: t }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  padding: '8px',
  border: 'none',
  borderRadius: t.radius[8],
  background: 'none',
  textAlign: 'left',
  cursor: 'pointer',
  ...hoverable(t),
}));

export const SuggestionTextColumn = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
  overflow: 'hidden',
});

export const SuggestionLogo = styled('img')({
  width: 24,
  height: 24,
  flexShrink: 0,
  borderRadius: '50%',
  objectFit: 'cover',
});
